import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .required()
      .trim()
      .min(1)
      .max(40)
      .label('Name'),
    type: yup
      .object()
      .required()
      .label('Type'),
    host: yup
      .string()
      .required()
      .trim()
      .min(1)
      .max(80)
      .label('Host'),
    db: yup
      .string()
      .required()
      .trim()
      .min(1)
      .max(40)
      .label('Database'),
    username: yup
      .string()
      .required()
      .trim()
      .min(1)
      .max(80)
      .label('Username'),
    password_api: yup
      .string()
      .nullable()
      .trim()
      .label('Password')
  })
  .required()

const resAddConnection = yupResolver(schema)

export default resAddConnection
